import { Controller, FieldValues, useController } from 'react-hook-form';

import { Checkbox } from '@/components/UI/Checkbox/Checkbox';

import { FieldError } from '../FieldError';
import { FieldProps } from '../types';

type CheckboxFieldProps<T extends FieldValues> = FieldProps<T> &
  Omit<React.ComponentPropsWithoutRef<typeof Checkbox>, keyof FieldProps<T>> & {
    tabIndex?: number;
  };

export const CheckboxField = <T extends FieldValues>({
  control,
  name,
  label,
  disabled,
  required,
  rules,
  defaultValue,
  ...rest
}: CheckboxFieldProps<T>) => {
  const { fieldState } = useController<T>({
    name,
    control,
    rules: { required: required ? 'dit veld is verplicht' : undefined, ...rules },
    defaultValue,
  });
  return (
    <div>
      <div style={{ pointerEvents: disabled ? 'none' : 'auto', display: 'flex', gap: '8px', flexDirection: 'row' }}>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field }) => (
            <>
              <Checkbox value={field.value} onChange={field.onChange} {...rest} name={name} />
              {label && (
                <span
                  style={{
                    cursor: !disabled ? 'pointer' : 'not-allowed',
                    color: !disabled
                      ? 'var(--tractie-color-content-default)'
                      : 'var(--tractie-color-background-accent-gray-default)',
                  }}
                  onClick={() => field.onChange(!field.value)}
                >
                  {label}
                </span>
              )}
            </>
          )}
        />

        <FieldError error={fieldState.error} width='auto' />
      </div>
    </div>
  );
};
